import { Auth } from 'aws-amplify'
import React, { useEffect, useState } from 'react'
import { Link, Redirect } from 'react-router-dom'
import Input from '../../Components/Input/Input'
import { LoginButton } from '../../Components/LoginButton'
import { useAuth } from '../../Utils.js/Auth/AuthDetails'
import classes from './Login.module.css'


function Login() {
    const { isAuthenticated, login: LoginGlobal, loginError, code, setLoginValues } = useAuth()
    const [username, setUserName] = useState('')
    const [password, setPassword] = useState('')
    const [verifyCode, setVerifyCode] = useState('')
    const [disabled, setDisabled] = useState(false)

    const login = () => {
        LoginGlobal(username, password)
    }


    useEffect(() => {
        if (
            username &&
            password
        ) {
            setDisabled(false)
        } else {
            setDisabled(true)
        }
    }, [
        username,
        password,

    ])


    useEffect(() => {
        if (loginError) {
            setLoginValues((prev) => {
                return {
                    ...prev,
                    loginError: null
                }
            })
        }
    }, [username, password, verifyCode])


    async function verifyEmailValidationCode() {
        await Auth.confirmSignUp(username, verifyCode)
            .then(() => {
                login()
            })
            .catch((e) => {
                setLoginValues((prev) => {
                    return {
                        ...prev,
                        loginError: e?.message
                    }
                })
            });
    }


    if (isAuthenticated) {
        console.log('auth');
        return <Redirect
            to={{
                pathname: '/player',
                state: { fromLogin: true }
            }}
        />
    }

    if (code === 'UserNotConfirmedException') {
        return (
            <div className={classes.container}>
                <Input
                    style={{
                        marginBottom: 24
                    }}
                    placeHolder='Verify'
                    value={verifyCode}
                    onChange={setVerifyCode}
                />

                <LoginButton
                    disabled={disabled}
                    style={{ margin: 'auto' }}
                    onPress={verifyEmailValidationCode}
                    title={'Verify'} />
            </div>
        )
    }

    return (
        <div className={classes.container}>
            <Input
                style={{
                    marginBottom: 24
                }}
                placeHolder='Email'
                value={username}
                onChange={setUserName}
            />
            <Input
                style={{
                    marginBottom: 48
                }}
                inputType='password' placeHolder='Password'
                value={password}
                onChange={setPassword}

            />
            <LoginButton
                disabled={disabled}
                style={{ margin: 'auto' }}
                onPress={login}
                title={'Login'} />
            <Link
                className={classes.forgotPasswordText}
                to="/forgotPassword">
                <span>Forgot your password?</span>
            </Link>

        </div>
    )
}

export default Login